import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "messages" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }

import { nextTick, ref } from 'vue';
import MessagesList from 'SharedDir/modules/Chats/MessagesList.vue';
import { Chats } from 'SharedDir/declarations/chats';
import ChatMessage from 'SharedDir/service/chats/classes/chat-message';
import SendChatMessage from 'SharedDir/modules/Chats/SendChatMessage.vue';

/**
 * Компонента-тред которая отвечает за отображение истори сообщений,
 * текстовое поле для написания этих самых сообщений
 *
 * Общается с окружающим миром только посредством свойства _messages_
 * и событий _send_ и _load_
 */

export default /*@__PURE__*/_defineComponent({
  ...{ name: 'Thread' },
  __name: 'Thread',
  props: {
    messages: {},
    chatName: {},
    dense: { type: Boolean, default: false }
  },
  emits: ["load", "send", "pin"],
  setup(__props: any, { expose: __expose, emit: __emit }) {


const props = __props;
const emits = __emit;
const refMessages = ref<typeof MessagesList>(null as any);

/**
 * Событие начала подгрузки елементов бесконечного скролла
 */
function proxyLoad(index: number, done: (stop?) => void) {
  emits('load', index, done);
}

/**
 * Событие отправки сообщения пользователем
 */
function proxySend(newMessage: Chats.NewMessage, done: () => void, reject: () => void) {
  emits('send', newMessage, done, reject);
}

function scrollToBottom(): void {
  refMessages.value.scrollToBottom();
}

async function reset() {
  await nextTick();
  refMessages.value.reset();
}
__expose({ reset, scrollToBottom });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.chatName), 1)
    ]),
    _createVNode(MessagesList, {
      ref_key: "refMessages",
      ref: refMessages,
      dense: _ctx.dense,
      messages: _ctx.messages,
      onLoad: proxyLoad,
      onDelete: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('delete', $event))),
      onUpdate: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update', ...$event)))
    }, null, 8, ["dense", "messages"]),
    _createVNode(SendChatMessage, {
      "model-value": null,
      class: "new-message",
      onSend: proxySend,
      onSent: scrollToBottom
    })
  ]))
}
}

})